var map = {
	"./_black_yellow.styl": 1134,
	"./_blue.styl": 1135,
	"./_brown_gold.styl": 1136,
	"./_dark_green.styl": 1137,
	"./_default.styl": 1138,
	"./_grey.styl": 1139,
	"./_light_grey.styl": 1140,
	"./_pink.styl": 1141,
	"./_purple.styl": 1142,
	"./_white_blue.styl": 1143,
	"./_white_pink.styl": 1144,
	"./_white_red.styl": 1145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1133;


//////////////////
// WEBPACK FOOTER
// ../colorscheme !/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[sha512:hash:base64:7].css!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-colorsheme-res-resolver!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader ^\.\/_.*\.styl$
// module id = 1133
// module chunks = 4